import React from 'react';
import TaskCard from './TaskCard';
import DroppableCategory from './DroppableCategory';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

const CategoryColumn = ({
  category,
  info,
  categoryTasks,
  taskNumbers,
  showTaskNumbers,
  showDescription,
  viewMode,
  theme,
  onToggleComplete,
  onEdit,
  onDelete,
  onStatusChange,
  onDoubleClick,
}) => {
  const taskIds = categoryTasks.map(task => task.id);

  return (
    <DroppableCategory
      id={category}
      className={`rounded-xl ${info.color} p-4 sm:p-5 shadow-lg hover:shadow-xl transition-shadow duration-200 min-h-[300px] sm:min-h-[400px]`}
      onDoubleClick={() => onDoubleClick(category)}
    >
      <div className={`inline-block px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg ${info.headerBg} mb-2`}>
        <h2 className={`font-bold ${info.textColor} ${info.titleFont || ''}`} style={theme === 'executive' ? { textTransform: 'uppercase' } : {}}>
          <span className="text-xl sm:text-2xl">{info.title}</span>
          <span className="text-base sm:text-lg ml-1.5">{info.label}</span>
        </h2>
      </div>
      <p className={`text-xs sm:text-sm font-bold ${theme === 'executive' ? 'text-[#0D2847]' : 'text-gray-700 dark:text-gray-400'}`}>{info.subtitle}</p>
      <p className={`text-xs sm:text-sm mt-1 mb-3 sm:mb-4 ${theme === 'executive' ? 'text-[#0D2847]' : 'text-gray-700 dark:text-gray-400'}`}>
        {categoryTasks.length} task{categoryTasks.length !== 1 ? 's' : ''}
      </p>

      <SortableContext items={taskIds} strategy={verticalListSortingStrategy}>
        <div className="space-y-2 sm:space-y-3">
          {categoryTasks.length === 0 ? (
            <div className="text-center py-12 text-slate-400 print-hide" data-testid={`empty-category-${category}`}>
              <p>No tasks in this category</p>
              <p className="text-xs mt-2">Drag tasks here</p>
            </div>
          ) : (
            categoryTasks.map((task, index) => (
              <TaskCard
                key={task.id}
                task={task}
                taskNumber={taskNumbers[index]}
                showTaskNumber={showTaskNumbers}
                onToggleComplete={onToggleComplete}
                onEdit={onEdit}
                onDelete={onDelete}
                onStatusChange={onStatusChange}
                showDescription={showDescription}
                showDate={viewMode !== 'today'}
              />
            ))
          )}
        </div>
      </SortableContext>
    </DroppableCategory>
  );
};

export default CategoryColumn;
